import { selectAdTags, selectBanners, selectLoadingBanners } from '../selectors/advertising';

import { useAppSelector } from './redux';

export const useBanners = () => useAppSelector(selectBanners);
export const useLoadingBanners = () => useAppSelector(selectLoadingBanners);
export const useAdProducts = () => useAppSelector(selectAdTags);
